module.exports = __webpack_public_path__ + "img/stripe-badge-white.2df963a7.png";